import { createApp } from 'vue'
import { createPinia } from 'pinia'
import router from './router'
import App from './App.vue'
import './assets/styles/main.css'
import { useAuthStore } from '@/stores/auth'

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)
app.use(router)

// Initialize auth store after pinia is installed
const authStore = useAuthStore()
authStore.initializeAuth()

// console.log('App initialized, auth state:', { isAuthenticated: authStore.isAuthenticated, user: authStore.user, token: authStore.token })

app.mount('#app')
